export default (url) => url.replace(/(https?:\/\/)|(\/)+/g, "$1$2");
